import React from 'react'
import moment from 'moment'
import _ from 'lodash'
import classNames from 'classnames'
import { CompactTable } from '@table-library/react-table-library/compact'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'

import { CURRENCY } from '../../../../../helpers/constants'

const CurrentAddon = ({ subscriptionDetails }) => {

  const tableTheme = useTheme([
    getTheme(),
    {
      Table: `
        --data-table-library_grid-template-columns:
          minmax(14rem, 2fr)
          minmax(12rem, 1fr)
          minmax(8rem, 1fr)
          minmax(14rem, 1fr)
          minmax(14rem, 1fr);
        margin: 0;
      `,
      HeaderCell: `
        border-top: 1px solid #e5e7eb;
        border-left: 1px solid #e5e7eb;
        font-weight: 600;
      `,
      Row: `
        font-size: 14px;

        .td {
          border-bottom: 1px solid #e5e7eb;
          border-left: 1px solid #e5e7eb;
        }
      `
    }
  ])

  if (!subscriptionDetails) return null

  const addons = subscriptionDetails.filter(
    item => item.product_type === 'addon'
  )

  if (_.isEmpty(addons)) return null

  const formatPrice = (price, currency) => {
    const symbol = CURRENCY?.[currency.toUpperCase()]?.symbol || ''
    return symbol + Number(price).toLocaleString()
  }

  const formatNextCharge = date => {
    const now = moment()
    const end = moment(date)

    const days = Math.ceil(
      moment.duration(end.diff(now)).asDays()
    )

    const formattedDate = end.format('Do MMM YYYY')

    return `In ${days} days, ${formattedDate}`
  }

  const columns = [
    {
      label: 'Name',
      renderCell: addon => addon.product_name
    },
    {
      label: 'Additional Increase in Volume',
      renderCell: addon => addon.limits
    },
    {
      label: 'Price',
      renderCell: addon =>
        formatPrice(
          addon.price.total_price,
          addon.price.currency
        )
    },
    {
      label: 'Next Charge on',
      renderCell: addon => {
        if (addon.status !== 'active') {
          return 'Not applicable'
        }

        return formatNextCharge(addon.end_time)
      }
    },
    {
      label: 'Status',
      renderCell: addon => {
        const isActive = addon.status === 'active'

        return (
          <div className="current-addon-status-wrapper">
            <span
              className={classNames({
                'current-addon-status-active': isActive,
                'current-addon-status-cancelled': !isActive
              })}
            >
              {isActive ? 'Active' : 'Cancelled'}
            </span>
            {isActive && (
              <span className="current-addon-status-cancel-link">
                Cancel Subscription
              </span>
            )}
            {!isActive && (
              <span className="current-addon-status-expiry">
                Expires {formatNextCharge(addon.end_time)}
              </span>
            )}
          </div>
        )
      }
    }
  ]

  const data = { nodes: addons }

  return (
    <div className="current-addon-container">
      <div className="current-addon-heading">
        Your Current Add-on Plan Details
      </div>
      <div className="current-addon-table-wrapper">
        <CompactTable
          columns={columns}
          data={data}
          theme={tableTheme}
        />
      </div>
    </div>
  )
}

export default CurrentAddon